import { ReactElement, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as actions from '@redux-actions/';

type RedirectProps = {
    to: string;
}

const Redirect = ({ to } : RedirectProps ) : ReactElement => {
    const navigate = useNavigate();
    const { search } = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.startLoading());
        navigate(to + search);
    },[]);

    return <></>
}

export default Redirect;